'use client';

import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import { ButtonOutline } from '@snack-uikit/button';
import { SearchSVG } from '@snack-uikit/icons';
import { Size } from '@snack-uikit/input-private';
import { Typography } from '@snack-uikit/typography';
import { useEffect } from 'react';

import { KEY_CODES } from '@/constant/common';
import { useModalsCtx, useServerDataCtx } from '@/hooks/ctx';
import { useKeyDown } from '@/hooks/useKeyDown';
import { useLayoutType } from '@/root/src/hooks';
import { isLargeThan } from '@/utils/layout';

import s from './styles.module.scss';

type InitialSearchInputProps = {
  placeholder: string;
  className?: string;
  size?: Size;
  iconClassname?: string;
  dataTestId?: string;
};

export function InitialSearchInput({
  placeholder,
  className,
  size,
  iconClassname,
  dataTestId,
}: InitialSearchInputProps) {
  const { openModal, closeModal } = useModalsCtx();
  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);
  useKeyDown(KEY_CODES.slash, () => openModal('initialSearch'));

  useEffect(() => {
    return () => closeModal('initialSearch');
  }, []);

  return (
    <ButtonOutline
      data-test-id={dataTestId}
      className={className}
      appearance='neutral'
      size={size}
      onClick={() => openModal('initialSearch')}
      icon={
        isLargeThan('tablet', layoutType) ? (
          <Typography.SansLabelM className={iconClassname || s.slash}> / </Typography.SansLabelM>
        ) : undefined
      }
      // TODO костыль, пока FF не починят
      label={
        (
          <div className={s.text_with_icon_wrapper}>
            <SearchSVG className={s.search_icon} />
            <Typography.SansLabelL className={s.search_text}> {placeholder} </Typography.SansLabelL>
          </div>
        ) as unknown as string
      }
    />
  );
}
